export const PLAN_OPTIONS = ["Digital Agent", "Alpha Investor", "Elite Team"];
export const SUBSCRIPTION_STATUS_OPTIONS = ["Trial", "Active", "Past Due", "Cancelled"];

const PLAN_FEATURES = {
  "Digital Agent": {
    salesCommandCenter: false,
    propnexImport: false,
    investmentTools: false,
    priceGapDetector: false,
    virtualStaging: false,
    exitMemo: false,
    personalizedSubdomain: false,
    teamManagement: false,
  },
  "Alpha Investor": {
    salesCommandCenter: true,
    propnexImport: true,
    investmentTools: true,
    priceGapDetector: true,
    virtualStaging: true,
    exitMemo: true,
    personalizedSubdomain: true,
    teamManagement: false,
  },
  "Elite Team": {
    salesCommandCenter: true,
    propnexImport: true,
    investmentTools: true,
    priceGapDetector: true,
    virtualStaging: true,
    exitMemo: true,
    personalizedSubdomain: true,
    teamManagement: true,
  },
};

export const normalizePlanType = (value) => ({
  Basic: "Digital Agent",
  Pro: "Alpha Investor",
  Enterprise: "Elite Team",
}[value] || value || "Digital Agent");

export const isReadOnlySubscription = (user) => user?.role === "agent" && ["Past Due", "Cancelled"].includes(user?.subscription_status);

export const hasPlanFeature = (user, featureKey) => {
  if (!user || user.role !== "agent") return true;
  if (isReadOnlySubscription(user)) return false;
  return Boolean(PLAN_FEATURES[normalizePlanType(user.plan_type)]?.[featureKey]);
};

export const getUpgradeCopy = (featureKey) => ({
  propnexImport: {
    title: "Upgrade to Alpha Investor",
    body: "Unlock compliant portfolio sync, consent-gated import, and a cleaner private portfolio workflow.",
  },
  salesCommandCenter: {
    title: "Upgrade to Alpha Investor",
    body: "Unlock the Sales Command Center with intent tracking, activity timelines, and hotter lead signals.",
  },
  investmentTools: {
    title: "Upgrade to Alpha Investor",
    body: "Unlock the Alpha Formula, Investor Cockpit, Price-Gap Detector, and Signature Investment Analysis.",
  },
  teamManagement: {
    title: "Upgrade to Elite Team",
    body: "Unlock shared branding, team seats, lead assignment, and leadership controls for your team.",
  },
}[featureKey] || {
  title: "Upgrade your plan",
  body: "This feature is reserved for higher SaaS tiers.",
});